import React from 'react';
import { Button, Link, useRecordContext,useTranslate } from 'react-admin';

const CreateSDOButton = () => {
    const record = useRecordContext();
    const translate = useTranslate();

    return (
    <Button
        component={Link}
        to={{
            pathname: '/sap_sdo_for_orders/create',
            state: {
              order: record,
            },
        }}
        className="create-sdo"
    >
        <span><i>+</i> {translate('resources.sap_digital_app_orders.fields.create_delivery')}</span>      
    </Button>
    )
};

export default CreateSDOButton;